// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1xHaA","title":"Images90_title__1HaCF","images":"Images90_images__13d04"};